import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import DebouncedInput from 'Common/Components/v2/DebouncedInput';
import { clearError, setBulkUpdateValue } from 'store/Contextualization/AssetDetail/actions';
import { selectErrorMessage, selectModalBulkUpdateValue } from 'store/Contextualization/AssetDetail/selectors';

const NameInput = () => {
  const dispatch = useDispatch();
  const bulkUpdateValue = useSelector(selectModalBulkUpdateValue);
  const message = useSelector((state) => selectErrorMessage('vulns', state));

  const onChange = (value) => {
    dispatch(setBulkUpdateValue(value));
    if (message) dispatch(clearError('vulns'));
  };

  return (
    <DebouncedInput
      value={ bulkUpdateValue }
      onChange={ onChange }
      name="name"
      title="vulnerability name"
      focusOnMount
      error={ !!message }
      errorMessage={ message }
    />
  );
};

export default NameInput;
